<template>
  <v-tooltip
    :open-on-click="touch"
    :open-on-hover="!touch"
    right
    :bottom="bottom"
    color="white"
    max-width="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!button" icon color="secondary" v-bind="attrs" v-on="on">
        <v-icon size="20">help</v-icon>
      </v-btn>
      <v-btn
        v-else
        class="light-background"
        text
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        What's this?
      </v-btn>
    </template>
    <v-card>
      <v-card-title v-if="title">
        <v-icon color="secondary" class="mr-2">help</v-icon>{{ title }}
      </v-card-title>
      <v-card-text class="subtitle-1">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-tooltip>
</template>

<script>
export default {
  name: "HelpTooltip",
  props: {
    title: { type: String },
    button: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false }
  },
  data: () => ({ touch: false }),
  beforeMount() {
    this.touch = matchMedia("(hover: none), (pointer: coarse)").matches;
  }
};
</script>
